<template>
	<div>
		<CModal title="Modifier un produit<" size="lg" :show.sync="showModal">
			<form
				ref="mainForm"
				:action="['/api/products/', item.id].join('')"
				method="post"
				axiosMethod="patch">
				<FormModal :item="item" />
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Sauvegarder</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import FormModal from './form-modal';
	export default {
		name: 'edit-modal',
		components: { FormModal },
		data() {
			return {
				showModal: false,
				item: {},
			};
		},

		methods: {
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.showModal = false;
						this.$toast.success('Modifié avec succès !');
						this.$emit('refresh');
					}
				});
			},
		},
	};
</script>
